import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  Button,
  TablePagination,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2';
import { contract, deletecontract } from '../../../components/Apis';
import { Download } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import Editcontract from './Editcontract';
import EditIcon from "@mui/icons-material/Edit";

const Contracts = () => {
  const [contracts, setContracts] = useState([]);
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [newContractFiles, setNewContractFiles] = useState([]);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [Selectedcontract, setSelectedcontract] = useState(null);

  const fetchContracts = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we load the data.',
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await contract();
      setContracts(response);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      Swal.close();
    }
  };

  useEffect(() => {
    fetchContracts();
  }, []);



  const handleUploadSubmit = () => {
    fetchContracts();
    if (!newContractFiles.length) {
      Swal.fire({
        title: 'Error',
        text: 'Please select at least one file.',
        icon: 'error',
      });
      return;
    }

    Swal.fire({
      title: 'Success',
      text: 'Contracts uploaded successfully.',
      icon: 'success',
    });
    setOpenUploadDialog(false);
  };

  const handleDeleteClick = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        await deletecontract(id);
        setContracts((prevContracts) =>
          prevContracts.filter((contract) => contract.id !== id)
        );
        Swal.fire('Deleted!', 'Contract has been deleted.', 'success');
      } catch (error) {
        console.error('Error deleting contract:', error);
        Swal.fire('Error!', 'Failed to delete the contract.', 'error');
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  const displayedContracts = contracts.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleEditClick = (broker) => {
    setSelectedcontract(broker); // حفظ البيانات التي سيتم تعديلها
    setOpenEditDialog(true); // فتح نافذة التعديل
  };
  return (
    <Box sx={{ p: 3 ,backgroundColor:"var(--seco-col)",height:"100vh"}}>
      <Box
        dir="ltr"
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}
      >
        <Typography variant="h6">Contracts</Typography>

      </Box>

      <TableContainer component={Paper} dir="ltr">
        <Table>
          <TableHead style={{ backgroundColor: "#F2F4F7" }}>
            <TableRow>
              <TableCell>Unit Name</TableCell>
              <TableCell>Owner Name</TableCell>
              <TableCell>Contract</TableCell>
              <TableCell>Signed Contract</TableCell>
              <TableCell>Profit</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedContracts.map((contract) => (
              <TableRow key={contract.id}>
                <TableCell>{contract.unit_name}</TableCell>
                <TableCell>{contract.owner_name}</TableCell>
                <TableCell>
                  <a href={contract.contract} target="_blank" download>
                    <IconButton
                      sx={{
                        backgroundColor: "transparent",
                        color: "var(--pri-col)",
                        "&:hover": {
                        }
                      }}
                    >
                      <Download />
                    </IconButton>
                  </a>
                </TableCell>
                <TableCell>
                  <a href={contract.signed_contract} target="_blank" download>
                    <IconButton
                      sx={{
                        backgroundColor: "transparent",
                        color: "var(--pri-col)",
                        "&:hover": {
                        }
                      }}
                    >
                      <Download />
                    </IconButton>
                  </a>
                </TableCell>
                <TableCell>{contract.profit}</TableCell>

                <TableCell>
                  <IconButton onClick={() => handleEditClick(contract)}
                    sx={{
                      backgroundColor: "transparent",
                      color: "var(--pri-col)",
                      "&:hover": {
                      }
                    }}
                    >
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteClick(contract.id)}
                    sx={{
                      backgroundColor: "transparent",
                      color: "var(--pri-col)",
                      "&:hover": {
                      }
                    }}
                    >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box dir="ltr">
        <TablePagination
          component="div"
          count={contracts.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>

      <Editcontract
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        fetchContracts={fetchContracts}
        contract={Selectedcontract}
        onUpdate={(updatedBroker) => {
          setContracts((prevBrokers) =>
            prevBrokers.map((broker) =>
              broker.id === updatedBroker.id ? updatedBroker : broker
            )
          );
          setOpenEditDialog(false);
        }}
      />
    </Box>
  );
};

export default Contracts;
